import React, { useEffect, useState } from "react";
import axiosInstance from "../../../Config/axios";
import { API_URLS } from "../../../Config/API_URLS";
import bcde from "../../../Assets/bcde.webp";
import { useNavigate } from "react-router-dom";
import { bannerFn } from "../../../Services/Banner";
import { useMutation, useQueryClient } from "react-query";
import CustomDiv from "../../../Shared/CustomDiv";
import { Divider } from "@mui/joy";
import Text from "../../../Shared/Text";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";
import { setThemeMode } from "../../../Redux/Actions/ThemeMode";
import { CircularProgress } from "@mui/material";

const HomeProduct = () => {
  const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [dataaa, setDataaa] = useState([]);
  const [dataaaa, setDataaaa] = useState([]);
  const [banners, setBanners] = useState([]);
  const [dat1, setDat1] = useState([])
  const [isCart, setIsCart] = useState(false);
  const navigate = useNavigate();

  // const Product = () => {
  //   const reqBody = {
  //     add_quantity: 1,
  //   };
  //   axiosInstance.get(API_URLS.productList, reqBody).then((response) => {
  //     setData(response.data.data);
  //   });
  // };
  const dispatch = useDispatch();
  const handleLogin = () => {
    dispatch(setThemeMode(true));
  };
  const getCatagery = () => {
    axiosInstance
      .get(API_URLS.catagery)
      .then((response) => {
        setData(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getCatagery();
  }, []);
  const Products = () => {
    const reqBody = {
      add_quantity: 1,
    };
    axiosInstance.post(API_URLS.topRated, reqBody).then((response) => {
      setDataa(response.data.data.product_list);
    });
  };
  const Products1 = () => {
    const reqBody = {
      add_quantity: 1,
    };
    axiosInstance.post(API_URLS.productList, reqBody).then((response) => {
      setDat1(response.data.data.product_list);
    });
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const Productss = () => {
    const reqBody = {
      add_quantity: 1,
    };
    axiosInstance.post(API_URLS.recentlyAdded, reqBody).then((response) => {
      setDataaa(response.data.data.product_list);
    });
  };

  const Productsss = () => {
    const reqBody = {
      add_quantity: 1,
    };
    axiosInstance.post(API_URLS.mostViewed, reqBody).then((response) => {
      setDataaaa(response.data.data.product_list);
    });
  };
  const client = useQueryClient();
  const addToCart = (event, variantId) => {
    event.stopPropagation();
    const reqBody = new FormData();
    reqBody.append("product_id", variantId);
    reqBody.append("add_quantity", 1);
    setIsCart(true);
    axiosInstance
      .post(API_URLS.addToCart, reqBody)
      .then((response) => {
        client.refetchQueries(["myCartList"]);
        enqueueSnackbar(response.data.status);
        setIsCart(false);
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };
  const { mutate: banner } = useMutation(bannerFn, {
    onSuccess: (response) => {
      setBanners(response.data.data);
    },
  });

  useEffect(() => {
    // Product();
    Products();
    Productss();
    Productsss();
    banner();
    Products1();
  }, []);

  return (
    <>
      <div className="">
        <div className="flex justify-between lg:mt-5 lg:text-3xl text-xl font-bold text-gray-700 p-8 bg-gray-200 text-center">
          <p className="">TOP RATED PRODUCTS</p>
        </div>
        <div className="grid lg:grid-cols-5 xl:grid-cols-6 md:grid-cols-3 grid-cols-2 lg:gap-2 gap-3 px-4">
          {dataa?.map((product) => {
            return (
              <div
                className=" group-item group object-cover lg:h-[440px] h-fit lg:w-[215px] duration-200 lg:my-5 lg:-mb-5 hover:border border-black bg-white cursor-pointer"
                // onClick={() => navigate(`/product/${product?.id}`)}
                onClick={() =>
                  navigate(`/product/${product?.id}/${product?.variant_id}`)
                }
              >
                <span className="group ">
                  <img
                    src={product.image}
                    alt=""
                    className=" lg:w-[215px] lg:h-[300px] object-cover"
                  />
                  <div className="bg-white text-center object-cover lg:h-[75px] h-[95px] p-2 ">
                    <p className="lg:text-md text-sm font-bold ">
                      {" "}
                      {product.title}
                    </p>
                    <p className="lg:text-xl text-lg font-semibold">
                      ₹{product.actual_price
                      }
                    </p>
                  </div>
                  <span className="invisible group-hover:visible group-hover:scale-y-110">
                    <div className=" flex flex-col justify-center items-center bg-gray-800 hover:bg-black transition duration-200 p-1 px-4 rounded-md m-2 flex justify-center items-center text-white font-semibold">
                      {isCart ? (
                        <button>
                          <CircularProgress size={25} color="inherit" />
                        </button>
                      ) : (
                        <button
                          onClick={(event) =>
                            localStorage.getItem("token")
                              ? addToCart(event, product?.variant_id)
                              : handleLogin()
                          }
                        >
                          ADD TO BAG
                        </button>
                      )}
                    </div>
                  </span>
                </span>
              </div>
            );
          })}
        </div>
        <CustomDiv className="flex flex-col-reverse gap-10 justify-center items-center my-4 bg-[#F2F8F9] p-4 ">
          {banners?.slice(1, 2).map((banner) => {
            return (
              <div className="flex flex-col gap-2 lg:gap-5">
                <Divider textAlign="left" className="font-bold lg:text-xl">
                  <Text>{banner.brand_name}</Text>
                </Divider>
                <div className="flex gap-2 lg:gap-10">
                  <img src={banner.image} alt="" />
                </div>
              </div>
            );
          })}
        </CustomDiv>
        {/* <div className="flex justify-between items-center lg:mt-5 lg:text-3xl text-xl font-bold text-gray-700  p-8 bg-gray-200 text-center">
          <p className=""> hello</p>
        </div> */}
        <div className="grid lg:grid-cols-5 xl:grid-cols-6 md:grid-cols-3 grid-cols-2 lg:gap-2 gap-3 px-4">
          {dat1.map((product) => {
            return (
              <div
                className=" group-item group object-cover lg:h-[440px] h-fit lg:w-[215px] duration-200 lg:my-5 lg:-mb-5 hover:border border-black bg-white cursor-pointer"
                // onClick={() => navigate(`/product/${product?.id}`)}
                onClick={() =>
                  navigate(`/product/${product?.id}/${product?.variant_id}`)
                }
              >
                <span className="group ">
                  <img
                    src={product.image}
                    alt=""
                    className=" lg:w-[215px] lg:h-[300px] object-cover"
                  />
                  <div className="bg-white text-center object-cover lg:h-[75px] h-[95px] p-2 ">
                    <p className="lg:text-md text-sm font-bold ">
                      {" "}
                      {product.title}
                    </p>
                    <p className="lg:text-xl text-lg font-semibold">
                      ₹{product.actual_price
                      }
                    </p>
                  </div>
                  <span className="invisible group-hover:visible group-hover:scale-y-110">
                    <div className=" flex flex-col justify-center items-center bg-gray-800 hover:bg-black transition duration-200 p-1 px-4 rounded-md m-2 flex justify-center items-center text-white font-semibold">
                      {isCart ? (
                        <button>
                          <CircularProgress size={25} color="inherit" />
                        </button>
                      ) : (
                        <button
                          onClick={(event) =>
                            localStorage.getItem("token")
                              ? addToCart(event, product?.variant_id)
                              : handleLogin()
                          }
                        >
                          ADD TO BAG
                        </button>
                      )}
                    </div>
                  </span>
                </span>
              </div>
            );
          })}
        </div>

        {/* <div className="flex justify-between items-center lg:mt-5 lg:text-3xl text-xl font-bold text-gray-700  p-8 bg-gray-200 text-center">
          <p className=""> {data[1]?.Meta_Title}</p>
        </div> */}
        {/* <div className="grid lg:grid-cols-5 xl:grid-cols-6 md:grid-cols-3 grid-cols-2 lg:gap-2 gap-3 px-4">
          {data[1]?.product_deatils?.slice(0, 24).map((product) => {
            return (
              <div
                className=" group-item group object-cover lg:h-[440px] h-fit lg:w-[215px] duration-200 lg:my-5 lg:-mb-5 hover:border border-black bg-white cursor-pointer"
                // onClick={() => navigate(`/product/${product?.id}`)}
                onClick={() =>
                  navigate(`/product/${product?.id}/${product?.variant_id}`)
                }
              >
                <span className="group ">
                  <img
                    src={product.image}
                    alt=""
                    className=" lg:w-[215px] lg:h-[300px] object-cover"
                  />
                  <div className="bg-white text-center object-cover lg:h-[75px] h-[95px] p-2 ">
                    <p className="lg:text-md text-sm font-bold ">
                      {" "}
                      {product.variant_name?.slice(0, 50)}
                    </p>
                    <p className="lg:text-xl text-lg font-semibold">
                      ₹{product.price}
                    </p>
                  </div>
                  <span className="invisible group-hover:visible group-hover:scale-y-110">
                    <div className=" flex flex-col justify-center items-center bg-gray-800 hover:bg-black transition duration-200 p-1 px-4 rounded-md m-2 flex justify-center items-center text-white font-semibold">
                      {isCart ? (
                        <button>
                          <CircularProgress size={25} color="inherit" />
                        </button>
                      ) : (
                        <button
                          onClick={(event) =>
                            localStorage.getItem("token")
                              ? addToCart(event, product?.variant_id)
                              : handleLogin()
                          }
                        >
                          ADD TO BAG
                        </button>
                      )}
                    </div>
                  </span>
                </span>
              </div>
            );
          })}
        </div> */}

        {/* <div className="flex justify-between items-center lg:mt-5 lg:text-3xl text-xl font-bold text-gray-700  p-8 bg-gray-200 text-center">
          <p className=""> {data[2]?.Meta_Title}</p>
        </div> */}
        {/* <div className="grid lg:grid-cols-5 xl:grid-cols-6 md:grid-cols-3 grid-cols-2 lg:gap-2 gap-3 px-4">
          {data[2]?.product_deatils?.slice(0, 24).map((product) => {
            return (
              <div
                className=" group-item group object-cover lg:h-[440px] h-fit lg:w-[215px] duration-200 lg:my-5 lg:-mb-5 hover:border border-black bg-white cursor-pointer"
                // onClick={() => navigate(`/product/${product?.id}`)}
                onClick={() =>
                  navigate(`/product/${product?.id}/${product?.variant_id}`)
                }
              >
                <span className="group ">
                  <img
                    src={product.image}
                    alt=""
                    className=" lg:w-[215px] lg:h-[300px] object-cover"
                  />
                  <div className="bg-white text-center object-cover lg:h-[75px] h-[95px] p-2 ">
                    <p className="lg:text-md text-sm font-bold ">
                      {" "}
                      {product.variant_name?.slice(0, 50)}
                    </p>
                    <p className="lg:text-xl text-lg font-semibold">
                      ₹{product.price}
                    </p>
                  </div>
                  <span className="invisible group-hover:visible group-hover:scale-y-110">
                    <div className=" flex flex-col  bg-gray-800 hover:bg-black transition duration-200 p-1 px-4 rounded-md m-2 justify-center items-center text-white font-semibold">
                      {isCart ? (
                        <button>
                          <CircularProgress size={25} color="inherit" />
                        </button>
                      ) : (
                        <button
                          onClick={(event) =>
                            localStorage.getItem("token")
                              ? addToCart(event, product?.variant_id)
                              : handleLogin()
                          }
                        >
                          ADD TO BAG
                        </button>
                      )}
                    </div>
                  </span>
                </span>
              </div>
            );
          })}
        </div> */}

        <CustomDiv className="flex flex-col-reverse gap-10 justify-center items-center my-4 bg-[#F2F8F9] p-4 ">
          {banners?.slice(0, 1).map((banner) => {
            return (
              <div className="flex flex-col gap-2 lg:gap-5">
                <Divider textAlign="left" className="font-bold lg:text-xl">
                  <Text>{banner.brand_name}</Text>
                </Divider>
                <div className="flex gap-2 lg:gap-10">
                  <img className="w-full" src={banner.image} alt="" />
                </div>
              </div>
            );
          })}
        </CustomDiv>

        <div className="flex justify-between lg:text-3xl lg:mt-5 text-xl font-bold text-gray-700 p-8 bg-gray-200 text-center">
          <p className="">RECENTLY ADDED PRODUCTS</p>
        </div>
        <div className="grid lg:grid-cols-5 xl:grid-cols-6 md:grid-cols-3 grid-cols-2 lg:gap-2 gap-3 px-4">
          {dataaa?.map((product) => {
            return (
              <div
                className=" group-item group object-cover lg:h-[440px] h-fit lg:w-[215px] duration-200 lg:my-5 lg:-mb-5 hover:border border-black bg-white cursor-pointer"
                // onClick={() => navigate(`/product/${product?.id}`)}
                onClick={() =>
                  navigate(`/product/${product?.id}/${product?.variant_id}`)
                }
              >
                <span className="group ">
                  <img
                    src={product.image}
                    alt=""
                    className=" lg:w-[215px] lg:h-[300px] object-cover"
                  />
                  <div className="bg-white text-center object-cover lg:h-[75px] h-[95px] p-2 ">
                    <p className="lg:text-md text-sm font-bold ">
                      {" "}
                      {product.title}
                    </p>
                    <p className="lg:text-xl text-lg font-semibold">
                      ₹{product.actual_price
                      }
                    </p>
                  </div>
                  <span className="invisible group-hover:visible group-hover:scale-y-110">
                    <div className=" flex flex-col justify-center items-center bg-gray-800 hover:bg-black transition duration-200 p-1 px-4 rounded-md m-2 flex justify-center items-center text-white font-semibold">
                      {isCart ? (
                        <button>
                          <CircularProgress size={25} color="inherit" />
                        </button>
                      ) : (
                        <button
                          onClick={(event) =>
                            localStorage.getItem("token")
                              ? addToCart(event, product?.variant_id)
                              : handleLogin()
                          }
                        >
                          ADD TO BAG
                        </button>
                      )}
                    </div>
                  </span>
                </span>
              </div>
            );
          })}
        </div>

        <CustomDiv className="flex flex-col-reverse gap-10 justify-center items-center my-4 bg-[#F2F8F9] p-4 ">
          {banners?.slice(0, 1).map((banner) => {
            return (
              <div className="flex flex-col gap-2 lg:gap-5">
                <Divider textAlign="left" className="font-bold lg:text-xl">
                  <Text>{banner.brand_name}</Text>
                </Divider>
                <div className="flex gap-2 lg:gap-10">
                  <img src={banner.image} alt="" />
                </div>
              </div>
            );
          })}
        </CustomDiv>

        <div className="flex justify-between lg:text-3xl lg:mt-5 text-xl font-bold text-gray-700 p-8 bg-gray-200 text-center">
          <p className="">MOST VIEWED PRODUCTS</p>
        </div>
        <div className="grid lg:grid-cols-5 xl:grid-cols-6 md:grid-cols-3 grid-cols-2 lg:gap-2 gap-3 px-4">
          {dataaaa?.map((product) => {
            return (
              <div
                className=" group-item group object-cover lg:h-[440px] h-fit lg:w-[215px] duration-200 lg:my-5 lg:-mb-5 hover:border border-black bg-white cursor-pointer"
                // onClick={() => navigate(`/product/${product?.id}`)}
                onClick={() =>
                  navigate(`/product/${product?.id}/${product?.variant_id}`)
                }
              >
                <span className="group ">
                  <img
                    src={product.image}
                    alt=""
                    className=" lg:w-[215px] lg:h-[300px] object-cover"
                  />
                  <div className="bg-white text-center object-cover lg:h-[75px] h-[95px] p-2 ">
                    <p className="lg:text-md text-sm font-bold ">
                      {" "}
                      {product.title}
                    </p>
                    <p className="lg:text-xl text-lg font-semibold">
                      ₹{product.actual_price
                      }
                    </p>
                  </div>
                  <span className="invisible group-hover:visible group-hover:scale-y-110">
                    <div className=" flex flex-col justify-center items-center bg-gray-800 hover:bg-black transition duration-200 p-1 px-4 rounded-md m-2 flex justify-center items-center text-white font-semibold">
                      {isCart ? (
                        <button>
                          <CircularProgress size={25} color="inherit" />
                        </button>
                      ) : (
                        <button
                          onClick={(event) =>
                            localStorage.getItem("token")
                              ? addToCart(event, product?.variant_id)
                              : handleLogin()
                          }
                        >
                          ADD TO BAG
                        </button>
                      )}
                    </div>
                  </span>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default HomeProduct;
